import { SnShareInfo, SnOrganization, IHasContentType } from '@lib/api/entities';

export interface ISnIsSharable extends IHasContentType {
  id: string;
  isShared: boolean;
  shareInfo: SnShareInfo;
  organization: SnOrganization;
  downloadStatus?: any;
}
